<template>
  <div class="school-compare">
    <v-dialog
      v-model="showCompare"
      content-class="dialog-compare"
      >
      <v-card>
        <v-card-title>
          <v-layout
            align-center
            justify-space-between
            row
            fill-height
            wrap
            class="dialog-title"
            >
            <v-flex>{{ $t('Compare schools') }}</v-flex>
            <v-flex class="text-xs-right">
              <a href="#" @click.stop.prevent="showCompare = false">
                {{ $t('Close') }}
                <v-icon>close</v-icon>
              </a>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>

    <SchoolChart
      v-bind:chartType="chartType"
      :averageLabel="true"
    />

    </v-dialog>
  </div>
</template>

<script>
import SchoolChart from '@/components/SchoolMap/SchoolChart';
import RepositoryFactory from "@/services/RepositoryFactory";
const StorageService = RepositoryFactory.get('storage');

export default {
  name: "SchoolCompare",
  props: {
    schools: {
      type: Array,
      required: true
    },
  },
  components: {
    SchoolChart
  },
  data() {
    return {
      chartType: 'compare'
    };
  },
  methods: {
    async startSchoolData(indicator) {
      let vm = this;
      if (indicator == null) {
        indicator = {
          indicator: "Overall rating out of 10"
        };
      }
      let latestYear = StorageService.getItem('latestYear');
      latestYear = JSON.parse(latestYear);
      let schools = await this.$store.state.compareSchool;
      let schoolsData = [];
      let indicator_years = ["2014", "2015", "2016", "2017", "2018"];
      for (let school of schools) {
        school.chartData = {};
        let singleSchools = vm.schools[school.id];

        let reportCardDatas = [];
        let reportCardDataBottom = [];
        if (singleSchools && singleSchools['reportCardData']) {
          reportCardDatas = singleSchools['reportCardData'].slice(
            0,
            singleSchools['reportCardData'].length - 3
          );
          reportCardDataBottom = singleSchools['reportCardData'].slice(-3);
        }

        let label;
        reportCardDatas.forEach(reportCardData => {
          label = reportCardData["label"] !== undefined ? reportCardData["label"] : label !== undefined ? label : '';

          let desc = reportCardData["IndexDesc"].trim();
          desc = desc !== undefined ? desc.trim() : "";
          let indexDesc = label ? label + ": " + desc: desc;
          indexDesc = indexDesc.trim();
          school.chartData[indexDesc] = {};
          indicator_years.forEach(year => {
            if (year in reportCardData) {
              school.chartData[indexDesc][year] = reportCardData[year];
            }
          });
        });

        reportCardDataBottom.forEach(reportCardData => {
          let indexDesc = reportCardData["IndexDesc"].trim();
          school.chartData[indexDesc] = {};
          indicator_years.forEach(year => {
            if (year in reportCardData) {
              school.chartData[indexDesc][year] = reportCardData[year];
            }
          });
        });
        let currentIndicator = this.resolveIndicator(school, indicator.indicator);
        if (school['chartData'].hasOwnProperty(currentIndicator)) {
          schoolsData.push(school['chartData'][currentIndicator][latestYear[school.province + '_' + school.level]]);
        }
      }

      this.$store.commit("SET_SCHOOLS_DATA", schoolsData);
    },
    resolveIndicator(data, currentIndicator) {
      if (currentIndicator === 'Overall rating out of 10' && !data['chartData'].hasOwnProperty(currentIndicator)) {
        // Try french version.
        let currentIndicatorTranslation = 'Cote globale (sur 10)';
        if (data['chartData'].hasOwnProperty(currentIndicatorTranslation)) {
          return currentIndicatorTranslation;
        }
      }

      return currentIndicator;
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.startSchoolData();
    });
  },
  computed: {
    showCompare: {
      get: function() {
        return this.$store.state.dialogCompareSchool;
      },
      set: function(value) {
        this.$store.commit("SET_DIALOG_COMPARE_SCHOOL", value);
      }
    }
  }
};
</script>
